var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicantsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 4.63158H16.8V2.31579C16.8 1.03053 15.732 0 14.4 0H9.6C8.268 0 7.2 1.03053 7.2 2.31579V4.63158H2.4C1.068 4.63158 0.012 5.66211 0.012 6.94737L0 19.6842C0 20.9695 1.068 22 2.4 22H21.6C22.932 22 24 20.9695 24 19.6842V6.94737C24 5.66211 22.932 4.63158 21.6 4.63158ZM14.4 4.63158H9.6V2.31579H14.4V4.63158Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantsicon);
export default __webpack_public_path__ + "static/media/applicantsicon.9ae380266ff822087c0c1b8e60ef64d6.svg";
export { ForwardRef as ReactComponent };